import React, { FC, memo, ReactNodeArray, useCallback, useContext, useState } from 'react'
import { ThemeContext } from 'styled-components'
import { Carousel, ScreenContext } from 'react-components'

import CarouselDot from './carousel-dot'
import { HowItWorksStepTransport } from '@common/transports/deprecated-home-page-transport'
import HowItWorksStep from './how-it-works-step'
import { NonCarouselContainer } from './how-it-works-steps-styles'
import { AnalyticsService } from '@src/services'
import { homePageEventCategories } from '@src/services/analytics-service/categories'
import { homePageEventLabels } from '@src/services/analytics-service/labels'

const _initialSlide = 0

interface Props {
    steps: HowItWorksStepTransport[]
    isLoggedIn: boolean
}

// For the purpose of accessibility.
const _appendDots = (dots: ReactNodeArray) => <ul>{dots}</ul>

const _handleSwipe = () => {
    AnalyticsService.trackSwipeEvent(
        homePageEventCategories.HOW_IT_WORKS_SECTION,
        homePageEventLabels.howItWorksSection.CHANGE_CAROUSEL_SLIDE,
    )
}

const HowItWorksSteps: FC<Props> = ({ steps, isLoggedIn }) => {
    const [currentSlide, setCurrentSlide] = useState(_initialSlide)
    const theme = useContext(ThemeContext)
    const { isDesktop, isMobile, isTablet } = useContext(ScreenContext)
    const _customPaging = useCallback(
        index => (
            <CarouselDot
                fillColor={index === currentSlide ? theme.colors.tfwRed : theme.colors.tfwBlack12}
                label={index + 1}
            />
        ),
        [theme, currentSlide],
    )

    const _beforeChange = useCallback(
        (_, nextIndex) => {
            setCurrentSlide(nextIndex)
        },
        [setCurrentSlide],
    )

    return (
        <React.Fragment>
            {!isDesktop && (
                <Carousel
                    slidesToShow={isTablet ? 2 : 1}
                    arrows={false}
                    infinite={false}
                    centerMode={isMobile}
                    centerPadding={isMobile ? '20px' : undefined}
                    dots
                    initialSlide={_initialSlide}
                    beforeChange={_beforeChange}
                    onSwipe={_handleSwipe}
                    customPaging={_customPaging}
                    appendDots={_appendDots}
                >
                    {steps.map((step, index) => (
                        <HowItWorksStep
                            key={step.title}
                            step={step}
                            stepNumber={index + 1}
                            isLoggedIn={isLoggedIn}
                            isFirstStep={index === 0}
                            isLastStep={index === steps.length - 1}
                        />
                    ))}
                </Carousel>
            )}
            {isDesktop && (
                <NonCarouselContainer>
                    {steps.map((step, index) => (
                        <HowItWorksStep
                            key={step.title}
                            step={step}
                            stepNumber={index + 1}
                            isLoggedIn={isLoggedIn}
                            isFirstStep={index === 0}
                            isLastStep={index === steps.length - 1}
                        />
                    ))}
                </NonCarouselContainer>
            )}
        </React.Fragment>
    )
}

export default memo(HowItWorksSteps)
